export const SCROLLED_AWAY_THRESHOLD = 80;

export const isScrolledAwayFromBottom = (
  { scrollHeight = 0, scrollTop = 0, clientHeight = 0 } = {},
  threshold = SCROLLED_AWAY_THRESHOLD
) => scrollHeight - scrollTop - clientHeight > threshold;

export const latestMessageId = messages => messages.at(-1)?.id ?? null;
